import { useEffect, useState, type ReactNode } from 'react'
import { ListReady } from './listReady'

export function ListReadyProvider({ children }: { children: ReactNode }) {
  const [ready, setReady] = useState(false)
  // One flip after the first commit; nothing cascades from it.
  // eslint-disable-next-line react-hooks/set-state-in-effect
  useEffect(() => setReady(true), [])
  return <ListReady.Provider value={ready}>{children}</ListReady.Provider>
}
